import { orchestrator } from 'satcheljs';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { loadFavorites } from 'owa-favorites';
import { OutlookFavoriteServiceDataType } from 'owa-favorites-types';
import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import { BaseFolderType } from 'owa-folders';
import { getSingleValueSettingValueForKey } from 'owa-favorites/lib/utils/favoriteServiceDataUtils';
import { isFeatureEnabled } from 'owa-feature-flags';
import populatePublicFolderOutlookFavoriteStore from '../actions/populatePublicFolderOutlookFavoriteStore';
import getPublicFolders from '../services/getPublicFolders';
import addPublicFolderToStore from '../actions/addPublicFolderToStore';
import publicFolderFavoriteStore from '../store/publicFolderFavoriteStore';

export default orchestrator(loadFavorites, async () => {
    if (!isFeatureEnabled('tri-favorites-roaming')) {
        return;
    }

    let folderIds: string[] = [];
    const outlookFavorites = getUserConfiguration().Favorites
        ? getUserConfiguration().Favorites.value
        : null;

    if (!outlookFavorites) {
        // Nothing to load
        return;
    }

    outlookFavorites.forEach((serviceData: OutlookFavoriteServiceDataType) => {
        const isPublicFolderSetting = getSingleValueSettingValueForKey(
            serviceData,
            'IsPublicFolder'
        );

        if (isPublicFolderSetting && isPublicFolderSetting.toLowerCase() === 'true') {
            folderIds.push(getSingleValueSettingValueForKey(serviceData, 'FolderId'));
        }
    });

    let getFolderResponse = await getPublicFolders(folderIds);

    if (getFolderResponse) {
        getFolderResponse.Items.forEach((item: FolderInfoResponseMessage) => {
            item.Folders.forEach((folder: BaseFolderType) => {
                if (folder != null) {
                    addPublicFolderToStore(publicFolderFavoriteStore, folder);
                }
            });
        });

        populatePublicFolderOutlookFavoriteStore();
    }
});
